const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const getPath = (obj: unknown, path: string): unknown => {
  let current: unknown = obj;
  for (const key of path.split('.')) {
    if (!isRecord(current)) return undefined;
    current = current[key];
  }
  return current;
};

export const deletePath = (obj: Record<string, unknown>, path: string): boolean => {
  const keys = path.split('.');
  const last = keys.pop() as string;
  const parent = keys.length ? getPath(obj, keys.join('.')) : obj;
  if (!isRecord(parent) || !(last in parent)) return false;
  delete parent[last];
  return true;
};
